import { WeightSchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import {
  locationIdFormat,
  packingTemplateIdFormat,
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-ids/ids";
import { PackingTemplateSchema } from "@redotech/redo-model/inventory/packing-template";
import * as z from "zod";

const ProductSearchResultSchema_ = z.object({
  id: productIdFormat.schema,
  title: z.string(),
  sku: z.string().nullable(),
  upc: z.string().nullable(),
  barcodes: z.array(z.string()),
  imageUrl: z.string().nullable(),
  currentQuantity: z.bigint().default(0n), // Current quantity at the location
  accountId: z.string(),
  accountName: z.string(),
  weight: WeightSchema.nullable().default(null),
  defaultPackingTemplateId: packingTemplateIdFormat.schema
    .nullable()
    .default(null),
  packingTemplates: z.array(PackingTemplateSchema).default([]),
  productFamilyId: productFamilyIdFormat.schema.nullable().default(null),
  productFamilyTitle: z.string().nullable().default(null),
  optionsSortKey: z.array(z.number()).default([]),
});

export const ProductSearchResultSchema: z.ZodType<ProductSearchResult> =
  ProductSearchResultSchema_;
export interface ProductSearchResult
  extends z.infer<typeof ProductSearchResultSchema_> {}

export const searchProducts = {
  name: "searchProducts" as const,
  input: z.object({
    query: z.string(),
    locationId: locationIdFormat.schema.nullish(),
    limit: z.number().min(1).max(50).default(20),
    /** When true and locationId is provided, only return products with stock > 0 at that location */
    filterByStock: z.boolean().optional(),
  }),
  output: z.object({ products: z.array(ProductSearchResultSchema) }),
};
